import { useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import { exportAnalysisToPDF } from '../../utils/pdfExport';
import type { Analysis } from '../../types/models';
import { Button } from "@/components/ui/button";

interface InterviewSection {
  title: string;
  duration: string;
  questions: string[];
  redFlags: string[];
  greenFlags: string[];
}

interface ExportButtonProps {
  analysis: Analysis;
  selectedPerspective?: string;
  transformedSections?: InterviewSection[];
}

export function ExportButton({ analysis, selectedPerspective, transformedSections }: ExportButtonProps) {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    try {
      setIsExporting(true);
      await exportAnalysisToPDF(analysis, selectedPerspective, transformedSections);
    } catch (error) {
      console.error('Failed to export PDF:', error);
      // TODO: Add user feedback (e.g., toast notification)
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Button
      variant="outline"
      onClick={handleExport}
      disabled={isExporting}
      size="sm"
    >
      {isExporting ? (
        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
      ) : (
        <Download className="mr-2 h-4 w-4 text-primary" />
      )}
      {isExporting ? 'Exporting...' : 'Export PDF'}
    </Button>
  );
}